import { TFunction, TOptions } from 'i18next';
import locale from 'yup/lib/locale';
import { setLocale } from 'yup';

/**
 * Builds and sets a yup locale
 */
export default function initYupLocal(t: TFunction): void {
  //Build yup locale with i18next translation functions
  const yupLocale = Object.entries(locale).reduce(
    (out, [key, value]) => ({
      ...out,
      [key]: Object.keys(value as string).reduce((itemOut, childKey) => {
        // Built from yup's runtime locale, so the key can't be checked against
        // validation.json; defaultValue keeps i18next's miss behaviour (echo the key).
        const fullKey = `validation:${key}.${childKey}`;
        return { ...itemOut, [childKey]: (values: TOptions) => t(fullKey, { ...values, defaultValue: fullKey }) };
      }, {}),
    }),
    {},
  );
  setLocale(yupLocale);
}
